import {modelChecklist, modelConectaPro, modelSellerApp, modelWhatsapp} from "../../models/service-activation";

import { ConectaProController } from "./conecta-pro-controller";
import { SellerAppController } from "./seller-app-controller";
import { ChecklistController } from "./checklist-controller";
import { WhatsappController } from "./whatsapp-controller";


let conectaProController = null;
let sellerAppController = null;
let checklistController = null;
let whatsappController = null;

export function controllerWhatsapp() {
  if (!whatsappController) {
    whatsappController = new WhatsappController({
      models: {
        whatsapp: modelWhatsapp(),
      }
    })
  }
  return whatsappController;
}

export function controllerChecklist() {
  if (!checklistController) {
    checklistController = new ChecklistController({
      models: {
        checklist: modelChecklist(),
      }
    })
  }
  return checklistController;
}

export function controllerConectaPro() {
  if (!conectaProController) {
    conectaProController = new ConectaProController({
      models: {
        conectaPro: modelConectaPro(),
      }
    })
  }
  return conectaProController;
}
export function controllerSellerApp() {
  if (!sellerAppController) {
    sellerAppController = new SellerAppController({
      models: {
        sellerApp: modelSellerApp(),
      }
    })
  }
  return sellerAppController;
}
